module.exports = __webpack_public_path__ + "img/hospitality-section21.005b1302.svg";